export enum SubscriptionTrialStatus {
  ACTIVE,
  PAYFASTPASS,
  EXPIRED,
}
